import moment from "moment";
import { IDropdownData } from "../models/ICommon";
import { ISnapShots } from "../models/master/snapShot";
import { alertConstants, getAlertData } from "../helper/sweet-alert";

export function changePositionOnDrag(
  filteredItems: any,
  currentPos: number,
  newPos: number
) {
  let _filteredItems = [...filteredItems];
  let _items: any[] = [];
  let posChangedItem = _filteredItems.splice(currentPos, 1);
  _filteredItems.splice(newPos, 0, posChangedItem[0]);
  _items = prioratiseItems(_filteredItems);
  return _items;
}

export function prioratiseItems(_filteredItems: any) {
  let _items: any[] = [];
  _filteredItems.map((x: any, index: number) => {
    x.priority = index + 1;
    x.displayPriority = index + 1;
    _items.push(x);
  });
  return _items;
}

export function changeVisibilty(
  id: number,
  _displayOrNot: boolean,
  filteredItems: any
) {
  let index = filteredItems.findIndex((x: any) => x.id == id);
  let _afterFilteration = [];
  let _filteredItems = [...filteredItems];
  let selectedItem = _filteredItems.splice(index, 1);
  selectedItem[0].displayOrNot = _displayOrNot;
  selectedItem[0].priority = null;
  _afterFilteration = [
    ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
    ...selectedItem,
    ..._filteredItems.filter((x) => x.displayOrNot == false),
  ];
  let _items = prioratiseItems(_afterFilteration);
  return _items;
}

export function getUserRole() {
  let localStorageItem = localStorage.getItem("userRole");
  return localStorageItem as any;
}

export function getPageBlockData(snapShots?: ISnapShots[], pageblockId?: number) {
  return snapShots?.find((snapshot: any) => snapshot.id === pageblockId);
}

export function sortAlphabetically(list?: IDropdownData[]) {
  if (list === undefined) {
    return null;
  }
  return [...list].sort((a, b) => {
    const valueA = String(a.name).toLowerCase();
    const valueB = String(b.name).toLowerCase();
    return valueA.localeCompare(valueB);
  });
}

export function greetings() {
  const hours = moment().hour();
  if (hours >= 1 && hours < 12) return "Good Morning";
  if (hours >= 12 && hours < 16) return "Good Afternoon";
  return "Good Evening";
}

export function isTokenValid(): boolean {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function mailValidation(subject: string, content: string, toMailIds?: string[]) {
  let alertData = null;
  if (!subject) {
    alertData = getAlertData(alertConstants.custom, undefined, alertConstants.error, "Subject is required!");
  } else if (!content) {
    alertData = getAlertData(alertConstants.custom, undefined, alertConstants.error, "Message is required!");
  } else if (toMailIds?.length === 0) {
    alertData = getAlertData(alertConstants.custom, undefined, alertConstants.error, "Recipient email is required!");
  }
  return alertData
}